import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Quiz from "@/components/Quiz";
import { Trophy, XCircle } from "lucide-react";
import { t } from "@/i18n";

export default function ModuleTest() {
  const { mid } = useParams();
  const [questions, setQuestions] = useState(null);
  const [result, setResult] = useState(null);
  const nav = useNavigate();

  const load = () => {
    setResult(null); setQuestions(null);
    api.get(`/content/module-test/${mid}`).then((r) => setQuestions(r.data.questions)).catch(() => nav("/roadmap"));
  };
  useEffect(() => { load(); }, [mid]);

  if (questions === null) return <div className="text-muted-foreground">{t("lessoneditor.chargement")}</div>;

  const onDone = async ({ correct, total, results }) => {
    const { data } = await api.post(`/content/module-test/${mid}`, { correct, total, items: results });
    setResult({ ...data, correct, total });
  };

  if (result) {
    return (
      <div className="max-w-xl mx-auto rounded-2xl border bg-card p-8 text-center" data-testid="module-test-result">
        {result.passed ? <Trophy size={44} className="mx-auto mb-3 text-ocre" /> : <XCircle size={44} className="mx-auto mb-3 text-destructive" />}
        <h1 className="font-head text-2xl font-bold mb-1">{t("moduletest.test_du_module")} {result.score}%</h1>
        <p className={`font-medium mb-2 ${result.passed ? "" : "text-destructive"}`} style={result.passed ? { color: "#16A34A" } : {}}>
          {result.passed ? t("moduletest.module_valide_80") : t("moduletest.pas_encore_valide_il_faut_atteindre")}
        </p>
        <p className="text-sm text-muted-foreground mb-6">{result.correct}/{result.total} {t("moduletest.bonnes_reponses")} {result.passed ? "" : t("moduletest.revois_les_lecons_du_module_et")}</p>
        <div className="flex gap-3 justify-center flex-wrap">
          <button data-testid="retry-test" onClick={load} className="px-5 py-2.5 rounded-xl border font-medium hover:bg-secondary">{t("moduletest.recommencer_le_test")}</button>
          <button onClick={() => nav("/roadmap")} className="px-5 py-2.5 rounded-xl bg-primary text-primary-foreground font-medium">{t("moduletest.retour_au_parcours")}</button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto">
      <h1 className="font-head text-2xl font-bold mb-1">{t("moduletest.test_du_module_2")}</h1>
      <p className="text-muted-foreground mb-4">{t("moduletest.un_test_global_pour_verifier_que")}</p>
      <Quiz questions={questions} onDone={onDone} record={false} />
    </div>
  );
}
